import React from 'react'
import { IWalletActionApiType } from 'pages/Wallets/hooks/useWalletActionApi'
import { BaseErrorResponse } from 'types/beneficiaries'
import { PayoutsFeeEstimateResponse } from 'types/payoutsV2'
import { CommonPayoutsForm } from 'types/unifiedPayouts/unifiedPayouts'
import { WalletAction, WalletTabProps } from '../Modal/WalletModal'

export type PaySteps = 'form' | 'amount' | 'confirm' | 'complete'

export type PayForm = CommonPayoutsForm & {
  beneficiarySelection?: string
  errorMessage?: string
}

export type PayActionProps = WalletTabProps &
  IWalletActionApiType<PayForm, PaySteps> & {
    payFees?: PayoutsFeeEstimateResponse
    confirmAmount?: () => void
    action?: WalletAction
    feeError?: BaseErrorResponse
  }

/**
 * Pay Tab containing state, form and API data for each step
 */
export const Pay = ({
  loading,
  step,
  form,
  wallets,
  setLoading,
  setStep,
  ...otherProps
}: PayActionProps) => {
  return <></>
}
